class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'recently-viewed-products';
    this.maxStored = 12;
  }

  connectedCallback() {
    const currentHandle = this.dataset.currentHandle;
    const limit = parseInt(this.dataset.limit, 10) || 4;

    if (currentHandle) {
      this.recordView(currentHandle);
    }

    const handles = this.getStoredHandles().filter((handle) => handle !== currentHandle);

    if (handles.length === 0) {
      this.remove();
      return;
    }

    this.renderProducts(handles.slice(0, limit));
  }

  getStoredHandles() {
    try {
      const stored = JSON.parse(localStorage.getItem(this.storageKey));
      return Array.isArray(stored) ? stored : [];
    } catch (error) {
      return [];
    }
  }

  recordView(handle) {
    const handles = this.getStoredHandles().filter((existing) => existing !== handle);
    handles.unshift(handle);
    localStorage.setItem(this.storageKey, JSON.stringify(handles.slice(0, this.maxStored)));
  }

  renderProducts(handles) {
    const grid = this.querySelector('[data-recently-viewed-grid]');
    const sectionId = this.dataset.sectionId;

    if (!grid || !sectionId) return;

    Promise.allSettled(handles.map((handle) => this.fetchCard(handle, sectionId))).then((results) => {
      let rendered = 0;

      results.forEach((result) => {
        if (result.status === 'fulfilled' && result.value) {
          grid.appendChild(result.value);
          rendered += 1;
        }
      });

      if (rendered === 0) {
        this.remove();
      } else {
        this.classList.remove('hidden');
      }
    });
  }

  fetchCard(handle, sectionId) {
    return fetch(`/products/${handle}?section_id=${sectionId}`)
      .then((response) => {
        if (!response.ok) return null;
        return response.text();
      })
      .then((html) => {
        if (!html) return null;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const card = doc.querySelector('[data-recently-viewed-card]');
        if (!card) return null;
        const li = document.createElement('li');
        li.className = 'grid__item';
        li.innerHTML = card.innerHTML;
        return li;
      })
      .catch(() => null);
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
